exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "a[data-v-0690bfda],a[data-v-0690bfda]:focus,a[data-v-0690bfda]:hover{color:#2993ff}\n", ""]);

// exports
